import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { BCPCrown } from "../icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";

const CLOUDFRONT_URL = getEnvironmentVariable("SYSTEM_IMAGES_CLOUDFRONT");
const SUBSCRIBE_BANNER_IMAGE_SM = `${CLOUDFRONT_URL}/images/StatsPromo-sm.png`;
const SUBSCRIBE_BANNER_IMAGE_MD = `${CLOUDFRONT_URL}/images/StatsPromo-md.png`;
const SUBSCRIBE_BANNER_IMAGE_LG = `${CLOUDFRONT_URL}/images/StatsPromo-lg.png`;

export default function SubscribeBanner(props) {
  const {
    title = "Unlock Pro-Level Insights",
    description = "Stay ahead of the game with premium list search, historical data, and global statistics.",
    slimDescription = "Explore matchup data, unit performance, and faction trends.",
    buttonText = "Get Premium",
    href = "/subscription",
    sx
  } = props;

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: 3,
        overflow: "hidden",
        backgroundImage: {
          xs: `url(${SUBSCRIBE_BANNER_IMAGE_SM})`,
          sm: `url(${SUBSCRIBE_BANNER_IMAGE_MD})`,
          lg: `url(${SUBSCRIBE_BANNER_IMAGE_LG})`
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        gap: { xs: 1.5, sm: 3 },
        px: { xs: 2, sm: 3, lg: 4 },
        py: { xs: 2, sm: 3, lg: 2.5 },
        ...sx
      }}
    >
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography
          variant="h5"
          sx={{
            display: { xs: "none", sm: "block" },
            fontWeight: 700,
            mb: 0.5,
            color: "#B0AEFF"
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            display: { xs: "block", sm: "none" },
            color: "#FFFFFF",
            fontSize: "0.8125rem",
            fontWeight: 400,
            lineHeight: 1.45
          }}
        >
          {slimDescription}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            display: { xs: "none", sm: "block" },
            color: "#FFFFFF"
          }}
        >
          {description}
        </Typography>
      </Box>
      <Button
        focusRipple
        href={href}
        variant="contained"
        startIcon={<BCPCrown style={{ fontSize: "1em", width: "1em", paddingRight: "0.3em", paddingLeft: "0.3em" }} />}
        sx={{
          flexShrink: 0,
          whiteSpace: "nowrap",
          borderRadius: 2,
          minHeight: { xs: "36px", sm: "44px" },
          px: { xs: 1.25, sm: 3 },
          py: { xs: 1, sm: 1.25 },
          fontSize: { xs: "0.75rem", sm: "1rem" },
          backgroundColor: "#6B69B8",
          color: "#FFFFFF",
          "& .MuiButton-startIcon": {
            mr: { xs: 0.5, sm: 1 }
          },
          "&:hover": {
            backgroundColor: "#5D5BA0"
          }
        }}
      >
        {buttonText}
      </Button>
    </Box>
  );
}
